import React from "react";

export function IconWhiteCheck() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_55065_44081)">
        <path
          d="M3.78273 9.99993C3.47187 9.99993 3.17787 9.8545 2.98887 9.60507L0.4363 6.23407C0.1043 5.79564 0.190728 5.17136 0.629157 4.83922C1.0683 4.50693 1.69216 4.59393 2.0243 5.03207L3.70316 7.24893L7.92559 0.469216C8.2163 0.00278732 8.83016 -0.139927 9.29759 0.150359C9.76445 0.44093 9.90702 1.05522 9.61616 1.52207L4.62816 9.53064C4.45487 9.80907 4.15573 9.98422 3.82816 9.99907C3.81287 9.99964 3.79787 9.99993 3.78273 9.99993Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_55065_44081">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
